'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var parts = ['card', 'header', 'icon', 'body'];
var baseStyle = function baseStyle(props) {
  var isElevated = props.isElevated;
  return {
    card: {
      layerStyle: 'card',
      px: 2,
      py: 3,
      boxShadow: isElevated ? 'md' : 'sm'
    },
    header: {
      textStyle: 'heading',
      fontSize: 'md',
      pb: 2,
      display: 'flex',
      alignItems: 'center'
    },
    icon: {
      alignSelf: 'flex-start',
      color: 'blue.400',
      boxSize: 6,
      mr: 1.5
    },
    body: {
      fontSize: 'sm'
    }
  };
};
var SellerLeadCard = {
  parts: parts,
  baseStyle: baseStyle
};
exports["default"] = SellerLeadCard;